import { useQuery } from "react-query";
import { UIViewEnum } from "../../common/enums/UIViewEnum";
import NavigationDataService from "../../services/navigation-data-service/NavigationDataService";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseAvailableAdminViewsParameters = {
    groupID: number,
} & BaseUseQueryParameters<UIViewEnum[] | undefined>;

export function useAvailableAdminViews({
    groupID,
    enabled,
    onError,
    onSuccess,
    refreshSeconds
}: UseAvailableAdminViewsParameters) {
    return useQuery<UIViewEnum[], RestError>(
        keys.adminlist(groupID),
        ({ signal }) => {
            return NavigationDataService.getAvailableAdminViews(
                groupID,
                signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            refetchInterval: refreshSeconds ? refreshSeconds  * 1000 : false,
            keepPreviousData: true
        }
    );
}
